import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-sans font-bold break-normal text-gray-700 px-2 pb-2" }, " ショップ追加 ", -1)
const _hoisted_2 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "p-2 mt-4 rounded shadow bg-white" }
const _hoisted_6 = { class: "p-6" }
const _hoisted_7 = { class: "mb-2 last:mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "店舗", -1)
const _hoisted_9 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "text-xs text-pink-600" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "text-xs text-pink-600" }
const _hoisted_14 = { class: "mb-2 last:mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "住所", -1)
const _hoisted_16 = { class: "grid grid-cols-1 gap-3 md:grid-cols-3 mb-2" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { class: "text-xs text-pink-600" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "text-xs text-pink-600" }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = { class: "text-xs text-pink-600" }
const _hoisted_23 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "text-xs text-pink-600" }
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = { class: "text-xs text-pink-600" }
const _hoisted_28 = { class: "mb-2 last:mb-0" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "連絡先", -1)
const _hoisted_30 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = { class: "text-xs text-pink-600" }
const _hoisted_33 = { class: "text-right col-span-full mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, " 【" + _toDisplayString(_ctx.salon.id) + "】" + _toDisplayString(_ctx.salon.name) + " (" + _toDisplayString(_ctx.salon.kana) + ") ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.name_error }]),
                placeholder: "店舗名",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }, null, 2), [
                [_vModelText, _ctx.name]
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.name_error), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.kana_error }]),
                placeholder: "店舗名(カナ)",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kana) = $event))
              }, null, 2), [
                [_vModelText, _ctx.kana]
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.kana_error), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.postcode_error }]),
                placeholder: "郵便番号(XXX-XXXX)",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postcode) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPostcodeChanged && _ctx.onPostcodeChanged(...args)))
              }, null, 34), [
                [_vModelText, _ctx.postcode]
              ]),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.postcode_error), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.prefecture_error }]),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prefecture) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectures, (p) => {
                  return (_openBlock(), _createElementBlock("option", { key: p }, _toDisplayString(p), 1))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.prefecture]
              ]),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.prefecture_error), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.city_error }]),
                placeholder: "市区町村",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.city) = $event))
              }, null, 2), [
                [_vModelText, _ctx.city]
              ]),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.city_error), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.address_error }]),
                placeholder: "番地",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address) = $event))
              }, null, 2), [
                [_vModelText, _ctx.address]
              ]),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.address_error), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.building_error }]),
                placeholder: "建物",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.building) = $event))
              }, null, 2), [
                [_vModelText, _ctx.building]
              ]),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.building_error), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _ctx.telephone_error }]),
                placeholder: "電話番号(XXX-XXXX-XXXX)",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.telephone) = $event))
              }, null, 2), [
                [_vModelText, _ctx.telephone]
              ]),
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.telephone_error), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)), ["prevent"]))
      }, " 登録 ")
    ])
  ], 64))
}